var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7287_39751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 13.0435C10.9565 13.0435 3.52168 3.51305 3.51465 3.51473C5.68618 1.34316 8.68623 0 12 0C18.6273 0 24 5.37262 24 12L10.9565 13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 12C10.9565 12 3.52168 20.487 3.51465 20.4853C5.68618 22.6568 8.68623 24 12 24C18.6273 24 24 18.6274 24 12H10.9565Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51468C-1.17157 8.20096 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51468Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31546 12.0001C1.3089 12.0862 1.30444 12.173 1.30444 12.2609C1.30444 14.1338 2.82282 15.6522 4.69576 15.6522C6.56869 15.6522 8.08707 14.1338 8.08707 12.2609C8.08707 12.173 8.08262 12.0862 8.07605 12.0001H1.31546Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69583 10.4348C5.27213 10.4348 5.73931 9.96762 5.73931 9.39132C5.73931 8.81502 5.27213 8.34784 4.69583 8.34784C4.11953 8.34784 3.65234 8.81502 3.65234 9.39132C3.65234 9.96762 4.11953 10.4348 4.69583 10.4348Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3479 9.13046V12.5218C2.3479 14.319 4.69573 14.8696 4.69573 14.8696C4.69573 14.8696 7.04356 14.319 7.04356 12.5218V9.13046H2.3479Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69687 13.7775C4.26131 13.6207 3.39136 13.2202 3.39136 12.5217V10.1739H6.00009V12.5217C6.00009 13.2225 5.13023 13.6221 4.69687 13.7775Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21743 11.4783V10.9565L4.69571 10.6956L4.17395 10.9565V11.4783L3.91309 11.7391V12.7826H5.47834V11.7391L5.21743 11.4783Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7287_39751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/sx.2793b990e3097e885f6f351a57f73b20.svg";
export { ForwardRef as ReactComponent };